export default __webpack_public_path__ + "static/clientBg-402db30793e2400edb3e7682f3ae8aac.png";